import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto } from "shared/lib/styles";
import { theme } from "shared/lib/styles/theme";

import { EntityLink } from "scmp-app/components/entity-link";
import ImagePlusFlag from "scmp-app/components/plus/plus-flag/img-plus.svg";

export const StyledEntityLink = styled(EntityLink)``;

export const ArticleItem = styled.div`
  display: grid;
  grid:
    "flag ." max-content
    "headline headline" max-content
    "publish-date publish-date" max-content
    / minmax(0, auto) 1fr;

  inline-size: 100%;

  :not(:first-of-type) {
    margin-block-start: 8px;
    padding-block-start: 8px;
    border-block-start: 1px solid #dfdfdf;
  }

  ${theme.breakpoints.up("tablet")} {
    grid:
      "flag . ." max-content
      "headline headline publish-date" max-content
      / minmax(0, auto) 1fr auto;
    column-gap: 32px;
  }
`;

export const PlusFlag = styled(ImagePlusFlag)`
  grid-area: flag;

  display: block;

  margin-block-end: 4px;
`;

export const PublishDate = styled.div`
  grid-area: publish-date;

  display: flex;
  align-items: center;

  max-block-size: 21px;
  margin-block-start: 4px;

  color: #727272;
  font-weight: 400;
  font-size: 11px;
  font-family: ${fontRoboto};

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 0;
  }
`;

export const Headline = styled.h4`
  grid-area: headline;

  ${StyledEntityLink} {
    color: #000000;
    font-weight: 700;
    font-size: 14px;
    font-family: ${fontMerriweather};
    font-style: normal;
    line-height: 150%;
  }
`;
